module.exports = __webpack_public_path__ + "media/images/athletes/3931-5c1ab2eef4f797a3bcae245cf9c6c7fe.png";